import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { MessageUtil } from 'src/app/helpers/messages';

@Component({
  selector: 'app-view-company-record',
  templateUrl: './view-company-record.component.html',
  styleUrls: ['./view-company-record.component.scss']
})
export class ViewCompanyRecordComponent implements OnInit {
  photoLoading: boolean;
  recordDetails: any;
  picPreview: any;
  photoError: boolean;

  constructor(
    public dialogRef: MatDialogRef<ViewCompanyRecordComponent>,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private app: AppService

    ) {

     }

  ngOnInit(): void {
    this.getRecordDetails()
  }

  
  getRecordDetails(){
    this.photoLoading = true;
    this.app.recordService.getRecordDetails(this.app.helperService.getUserId(),"INDIVIDUAL",this.data.id)
    .subscribe(res => {
      if (res['message'] == MessageUtil.RESPONSE_SUCCESS) {
        this.recordDetails = res['data']
        this.picPreview = this.recordDetails.identification.photo
        this.photoLoading = false
        this.photoError = false

  
        // this.snack.openSnackBar('Successfull', 'Close', 'Success', 'center','bottom')
    
        
      }
      else { 
        this.photoLoading = false
        this.photoError = true

        // this.snack.openSnackBar(res['data'], 'Close', 'Error', 'start')
      }
    }, err => {
      this.photoLoading = false
      this.photoError = true

      // this.snack.openSnackBar( MessageUtil.SAVE_NOT_DONE, 'Close', 'Error', 'start');
    }
    )
  }

  closeModal() {
    this.dialogRef.close('')
  }
  viewMore(){
    this.router.navigate(['app/records/view-company/'+this.data.id])
    this.dialogRef.close('')


    
  }

}
